import axios from "../../axios/index.js";

export default {
    fetchReport(id) {
        return axios.get(`/report/${id}`);
    },
    fetchReports() {
        return axios.get("/report/");
    },
    addReport(payload) {
        return axios.post("/report/add", payload);
    },
    addFileToReport(payload) {
        var formData = new FormData();
        formData.append("report", payload.report);

        return axios.post("/report/addFile", formData);
    },
    editReport(payload) {
        return axios.put(`/report/${payload.Id}`, payload);
    },
    deleteReport(id) {
        return axios.delete(`/report/${id}`);
    }
}